import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {ACTION_REASON, FREQUENCY_OPTIONS, LICENSE_STATUS, SERVICE_NAME} from "../../shared/utils/Constants";
import FormSection from "../../shared/component/form/FormSection";
import DateInput from "../../shared/component/form/DateInput";
import LicenseService from "../../shared/service/LicenseService";
import {InputNumber} from "primereact/inputnumber";
import {toast} from "react-toastify";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";
import KeyAndValueColumn from "../../shared/component/dataTable/columns/KeyAndValueColumn.json";
import {Checkbox} from "primereact/checkbox";
import '../../shared/styles/SettingsPage.css';

const defaultLicense = {
    id: null,
    licenseStatus: 'ACTIVE',
    actionReason: 'SERVICE_REGISTERED',
    actionReasonDescription: '',
    serviceName: '',
    validDays: 0,
    clientCreatedDate: null,
    updateDate: null,
    remainingDays: null,
    skipCheck: false,
    resetClient: false,
    till: true,
    icr: false,
    extraData: {},
    bssId: '',
    updatePeriod: '0 0 */6 * * *',
    ipAddress: '',
    appVersion: '',
    noOfClients: 1,
    licenceCode: '',
    clientCodes: '',
    hardwareSerial: '',
    issueDate: null,
    syncData: false,
    syncReport: false,
    syncTransaction: false,
    kitchenDisplay: false,
    orderDisplay: false,
    hidePriceForWebMenu: false

};

const defaultExtraData = {
    key: '',
    value: ''
}
export default class AppLicenseSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
            extraData: Object.assign({}, defaultExtraData),
            renderExtraDataDeleteButton: false,
            pageMode: null,
            credentialList: []
        }
        this.licenseService = new LicenseService();
    }


    renderLicenses() {
        return (
            <div>


                <FormSection title={"License"}>
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                                  onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                  show={this.state.displayShowStatusConfirmDialog}
                                  message={this.state.noticeResponse}/>
                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="serviceName">
                                    <Translate contentKey="merchantBranch.serviceName">Service
                                        Name</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="serviceName"
                                    disabled={!this.state.licenseSaveButtonRender || !GeneralUtils.isNullOrEmpty(this.state.license.id)}
                                    value={this.state.license.serviceName}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {SERVICE_NAME.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>
                        <Col md="6">
                            <AvGroup>
                                <Label for="licenseStatus">
                                    <Translate contentKey="merchantBranch.licenseStatus">License
                                        Status</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="licenseStatus"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.licenseStatus}
                                    onChange={this.__handleChangeStatus}>
                                    <option value='' key=''/>
                                    {LICENSE_STATUS.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="actionReason">
                                    <Translate contentKey="merchantBranch.actionReason">Action
                                        Reason</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="actionReason"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.actionReason}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {ACTION_REASON.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>

                        <Col md="6">
                            <AvGroup>
                                <Label for="actionReasonDescription">
                                    <Translate
                                        contentKey="merchantBranch.actionReasonDescription">Description</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="actionReasonDescription"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    validate={{
                                        maxLength: {
                                            value: 255,
                                            errorMessage: "You can enter up to 255 characters in this field."
                                        }
                                    }}
                                    value={this.state.license.actionReasonDescription}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="validDays">
                                    <Translate
                                        contentKey="merchantBranch.validDays">Valid Days</Translate>
                                </Label>

                                <InputNumber value={this.state.license.validDays}
                                             disabled={!this.state.licenseSaveButtonRender}
                                             name="validDays"
                                             min={0} max={100}
                                             className="input-group"
                                             onChange={this.__handleChange}
                                             showButtons/>


                            </AvGroup>
                        </Col>
                        <Col md="6">
                            <AvGroup>
                                <Label for="remainingDaysText">
                                    <Translate contentKey="merchantBranch.remainingDaysText">Remaining Days
                                    </Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="remainingDaysText"
                                    disabled={true}
                                    value={this.state.license.remainingDaysText}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="createDate">
                                    <Translate
                                        contentKey="merchantBranch.createDate">Create Date</Translate>
                                </Label>

                                <DateInput
                                    name="clientCreatedDate"
                                    onChange={this.__handleChange}
                                    disabled={true}
                                    format={"DD/MM/YYYY"}
                                    value={this.state.license.clientCreatedDate}/>

                            </AvGroup>

                        </Col>

                        <Col md="6">
                            <AvGroup>
                                <Label for="updateDate">
                                    <Translate
                                        contentKey="merchantBranch.updateDate">Update Date</Translate>
                                </Label>

                                <DateInput
                                    name="updateDate"
                                    format={"DD/MM/YYYY"}
                                    onChange={this.__handleChange}
                                    disabled={true}
                                    value={this.state.license.updateDate}/>

                            </AvGroup>

                        </Col>
                    </Row>

                    {(this.state.license.serviceName == "WEB_BACK_OFFICE") && this.renderWebBackOfficeFields()}

                    {(this.state.license.serviceName == "ORDER_DISPLAY") && this.renderOrderDisplayFields()}

                    {(this.state.license.serviceName == "INVOICE") && this.renderInvoiceFields()}

                    {(this.state.license.serviceName == "WEB_MENU") && this.renderWebMenuFields()}

                    {(this.state.license.serviceName == "ARTPOS" || this.state.license.serviceName == "PRINTSEL" || this.state.license.serviceName == "ARTOFFICE") && this.renderKeyAndValueList()}


                    <div className="settings-page__actions settings-page__actions--compact">
                        {!this.state.licenseSaveButtonRender &&
                            <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                this.setState({licenseSaveButtonRender: true});
                            }}>
                                <Translate contentKey="entity.action.add">Edit</Translate>
                            </Button>}
                        {this.state.licenseSaveButtonRender &&
                            <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                if (GeneralUtils.isNullOrEmpty(this.state.license.serviceName) || GeneralUtils.isNullOrEmpty(this.state.license.licenseStatus) || GeneralUtils.isNullOrEmpty(this.state.license.actionReason)
                                ) {
                                    return toast.warn("Please fill the required fields!");
                                } else {
                                    let data = this.state.license;
                                    data["updateDate"] = new Date();
                                    this.props.saveAppLicense(data);
                                }

                            }}>
                                <Translate contentKey="entity.action.add">Save</Translate>
                            </Button>
                        }

                        {this.state.licenseSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                            <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                this.showChangeStatusConfirmDialog(true)
                            }}>
                                <Translate contentKey="entity.action.add">Delete</Translate>
                            </Button>}
                    </div>

                </FormSection>

                <div className="settings-page__actions settings-page__actions--compact">
                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close" onClick={() => {
                        this.setState({
                            licenseSaveButtonRender: false
                        });
                        this.props.closeDisplayDialog();

                    }}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        )
    };


    render() {
        return (
            <div className="settings-page settings-page--embedded">
                {this.renderLicenses()}
            </div>
        );
    }

    delete = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.props.deleteAppLicense(this.state.license.id);
        }

        return undefined;
    }

    setChecked = (name, value) => {
        let license = this.state.license;
        license[name] = value;
        this.setState({license: license});
    }

    renderWebMenuFields() {
        return (

            <div>

                <FormSection title={"Web Menu"}>
                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="hidePriceForWebMenu">
                                    <Translate contentKey="skipCheck">Hide Price&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("hidePriceForWebMenu", e.checked)}
                                          name="hidePriceForWebMenu"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.hidePriceForWebMenu}
                                          checked={this.state.license.hidePriceForWebMenu}></Checkbox>


                            </AvGroup>
                        </Col>

                    </Row>
                </FormSection>
            </div>
        );
    }

    renderOrderDisplayFields() {
        return (

            <div>

                <FormSection title={"Order Display"}>
                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="skipCheck">
                                    <Translate contentKey="skipCheck">Kitchen Display&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("kitchenDisplay", e.checked)}
                                          name="kitchenDisplay"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.kitchenDisplay}
                                          checked={this.state.license.kitchenDisplay}></Checkbox>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="skipCheck">
                                    <Translate contentKey="skipCheck">Order Display&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("orderDisplay", e.checked)}
                                          name="orderDisplay"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.orderDisplay}
                                          checked={this.state.license.orderDisplay}></Checkbox>


                            </AvGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        );
    }

    renderInvoiceFields() {
        return (

            <div>

                <FormSection title={"Invoice"}>
                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="hidePriceForWebMenu">
                                    <Translate contentKey="skipCheck">Frequency</Translate>
                                </Label>

                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="creditFrequency"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.creditFrequency}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {FREQUENCY_OPTIONS.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate
                                        contentKey="merchantBranch.tradingName">Credit</Translate>
                                </Label>
                                <AvField
                                    type="number"
                                    className="form-control"
                                    name="credit"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.credit}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate
                                        contentKey="merchantBranch.tradingName">Credit Used</Translate>
                                </Label>
                                <AvField
                                    type="number"
                                    className="form-control"
                                    name="creditUsed"
                                    disabled={true}
                                    value={this.state.license.creditUsed}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate
                                        contentKey="merchantBranch.tradingName">Remaining Credit</Translate>
                                </Label>
                                <AvField
                                    type="number"
                                    className="form-control"
                                    name="remainingCredit"
                                    disabled={true}
                                    value={this.state.license.remainingCredit}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>

                    </Row>
                </FormSection>
            </div>
        );
    }

    renderWebBackOfficeFields() {
        return (

            <div>

                <FormSection title={"Web Back Office"}>
                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="skipCheck">
                                    <Translate contentKey="skipCheck">Report&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("syncReport", e.checked)}
                                          name="syncReport"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.syncReport}
                                          checked={this.state.license.syncReport}></Checkbox>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="skipCheck">
                                    <Translate contentKey="skipCheck">Transaction&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("syncTransaction", e.checked)}
                                          name="syncTransaction"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.syncTransaction}
                                          checked={this.state.license.syncTransaction}></Checkbox>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="skipCheck">
                                    <Translate contentKey="skipCheck">Data&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("syncData", e.checked)}
                                          name="syncData"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.syncData}
                                          checked={this.state.license.syncData}></Checkbox>


                            </AvGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        );
    }

    normalizeLicenseExtraData = (license) => {
        const normalized = Object.assign({}, license);
        if (!normalized.extraData || typeof normalized.extraData !== 'object' || Array.isArray(normalized.extraData)) {
            normalized.extraData = {};
        } else {
            normalized.extraData = Object.assign({}, normalized.extraData);
        }
        return normalized;
    }

    getLicenseExtraDataEntries = () => {
        const extraData = this.state.license.extraData;
        if (!extraData || typeof extraData !== 'object' || Array.isArray(extraData)) {
            return [];
        }
        return Object.entries(extraData).map(([key, value]) => ({key, value}));
    }

    saveExtraDataEntry = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.extraData.key) || GeneralUtils.isNullOrEmpty(this.state.extraData.value)) {
            return toast.warn("Please fill key and value");
        }

        const license = this.normalizeLicenseExtraData(this.state.license);
        license.extraData[this.state.extraData.key] = this.state.extraData.value;
        this.setState({
            license: license,
            renderExtraDataDeleteButton: false,
            extraData: Object.assign({}, defaultExtraData)
        });
    }

    deleteExtraDataEntry = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.extraData.key)) {
            return toast.warn("Please fill key");
        }

        const license = this.normalizeLicenseExtraData(this.state.license);
        delete license.extraData[this.state.extraData.key];
        this.setState({
            license: license,
            extraData: Object.assign({}, defaultExtraData),
            renderExtraDataDeleteButton: false
        });
    }

    renderKeyAndValueList() {
        const extraDataArray = this.getLicenseExtraDataEntries();

        return (

            <div>

                <FormSection title={"Artpos"}>
                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="skipCheck">
                                    <Translate contentKey="skipCheck">Skip Control&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("skipCheck", e.checked)}
                                          name="skipCheck"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.skipCheck}
                                          checked={this.state.license.skipCheck}></Checkbox>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="resetClient">
                                    <Translate contentKey="resetClient">Reset Clients&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("resetClient", e.checked)}
                                          name="resetClient"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.resetClient}
                                          checked={this.state.license.resetClient}></Checkbox>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="till">
                                    <Translate contentKey="till">Till&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("till", e.checked)}
                                          name="till"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.till}
                                          checked={this.state.license.till}></Checkbox>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="icr">
                                    <Translate contentKey="icr">Icr&nbsp;</Translate>
                                </Label>

                                <Checkbox onChange={(e) => this.setChecked("icr", e.checked)}
                                          name="icr"
                                          disabled={!this.state.licenseSaveButtonRender}
                                          value={this.state.license.icr}
                                          checked={this.state.license.icr}></Checkbox>


                            </AvGroup>
                        </Col>
                    </Row>

                    <Row>

                        <Col md="6">
                            <AvGroup>
                                <Label for="bssId">
                                    <Translate
                                        contentKey="merchantBranch.bssId">Reg No</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="bssId"
                                    disabled={true}
                                    validate={{
                                        maxLength: {
                                            value: 255,
                                            errorMessage: "You can enter up to 255 characters in this field."
                                        }
                                    }}
                                    value={this.state.license.bssId}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>

                        <Col md="6">
                            <AvGroup>
                                <Label for="hardwareSerial">
                                    <Translate
                                        contentKey="merchantBranch.hardwareSerial">Serial</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="hardwareSerial"
                                    disabled={true}
                                    validate={{
                                        maxLength: {
                                            value: 255,
                                            errorMessage: "You can enter up to 255 characters in this field."
                                        }
                                    }}
                                    value={this.state.license.hardwareSerial}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>
                    </Row>

                    <Row>

                        <Col md="6">
                            <AvGroup>
                                <Label for="ipAddress">
                                    <Translate
                                        contentKey="merchantBranch.ipAddress">Ip</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="ipAddress"
                                    disabled={true}
                                    value={this.state.license.ipAddress}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>


                        <Col md="6">
                            <AvGroup>
                                <Label for="updatePeriod">
                                    <Translate
                                        contentKey="merchantBranch.updatePeriod">Update Period</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="updatePeriod"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.updatePeriod}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>


                    </Row>

                    <Row>

                        <Col md="6">
                            <AvGroup>
                                <Label for="appVersion">
                                    <Translate
                                        contentKey="merchantBranch.appVersion">Version</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="appVersion"
                                    disabled={true}
                                    value={this.state.license.appVersion}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>


                        <Col md="6">
                            <AvGroup>
                                <Label for="noOfClients">
                                    <Translate
                                        contentKey="merchantBranch.noOfClients">Clients</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="noOfClients"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.noOfClients}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>


                    </Row>

                    <Row>

                        <Col md="6">
                            <AvGroup>
                                <Label for="licenceCode">
                                    <Translate
                                        contentKey="merchantBranch.licenceCode">Licence Number</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="licenceCode"
                                    disabled={true}
                                    value={this.state.license.licenceCode}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>


                        <Col md="6">
                            <AvGroup>
                                <Label for="issueDate">
                                    <Translate
                                        contentKey="merchantBranch.issueDate">Issue Date</Translate>
                                </Label>

                                <DateInput
                                    name="issueDate"
                                    format={"DD/MM/YYYY"}
                                    onChange={this.__handleChange}
                                    disabled={true}
                                    value={this.state.license.issueDate}/>

                            </AvGroup>

                        </Col>


                    </Row>
                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="noOfClients">
                                    <Translate
                                        contentKey="merchantBranch.noOfClients">Client Ids</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="clientCodes"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.clientCodes}
                                    onChange={this.__handleChange}/>
                            </AvGroup>


                        </Col>

                    </Row>

                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="activationCode">
                                    <Translate
                                        contentKey="merchantBranch.activationCode">Activation Code</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="activationCode"
                                    disabled={true}
                                    value={this.state.license.activationCode}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </Col>
                        <Col md="4">
                            {!GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                                <Button color="outline-primary" className="settings-page__btn--action"
                                        onClick={() => {

                                            this.licenseService.generateActivationCode(this.state.license.id)
                                                .then((response) => {
                                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {

                                                        this.setState({
                                                            license: response,
                                                            licenseTemp: Object.assign({}, response),
                                                            licenseSaveButtonRender: false
                                                        })

                                                    }
                                                });

                                        }}>
                                    <Translate contentKey="entity.action.add">Generate Code</Translate>
                                </Button>
                            }

                        </Col>


                    </Row>


                    <FormSection title={"Extra Data"}>
                        <Row>
                            <Col md="4">
                                <AvGroup>
                                    <Label for="key">
                                        <Translate contentKey="merchantBranch.key">Key
                                        </Translate>
                                    </Label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="key"
                                        disabled={!this.state.licenseSaveButtonRender}
                                        value={this.state.extraData.key}
                                        onChange={this.__handleChangeExtraData}/>
                                </AvGroup>
                            </Col>
                            <Col md="4">
                                <AvGroup>
                                    <Label for="value">
                                        <Translate contentKey="merchantBranch.value">Value
                                        </Translate>
                                    </Label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="value"
                                        disabled={!this.state.licenseSaveButtonRender}
                                        value={this.state.extraData.value}
                                        onChange={this.__handleChangeExtraData}/>
                                </AvGroup>
                            </Col>

                            <Col md="4">
                                <div className="settings-page__actions settings-page__actions--inline">
                                <Button disabled={!this.state.licenseSaveButtonRender} color="outline-primary"
                                        className="settings-page__btn--save" onClick={this.saveExtraDataEntry}>
                                    <Translate contentKey="entity.action.cancel">Save</Translate>
                                </Button>
                                {this.state.renderExtraDataDeleteButton &&
                                    <Button color="outline-danger" disabled={!this.state.licenseSaveButtonRender}
                                            className="settings-page__btn--delete"
                                            onClick={this.deleteExtraDataEntry}>
                                        <Translate contentKey="entity.action.cancel">Delete</Translate>
                                    </Button>
                                }
                                </div>
                            </Col>


                        </Row>


                        <DataTableAll
                            fields={KeyAndValueColumn.fields}
                            objectName={KeyAndValueColumn.name}
                            data={extraDataArray}
                            rows={5}
                            selectionMode="single" onDataSelect={this.onDataSelect}
                        />


                    </FormSection>


                </FormSection>
            </div>
        );
    }

    onDataSelect = (data) => {
        this.setState({
            extraData: {key: data.key, value: data.value},
            renderExtraDataDeleteButton: true
        });
    }

    licenseSaveButtonRender = () => {
        this.setState({licenseSaveButtonRender: true});
    }

    setData = (data) => {
        const license = this.normalizeLicenseExtraData(data);
        this.setState({
            license: license,
            licenseTemp: Object.assign({}, license),
            licenseSaveButtonRender: false,
            renderExtraDataDeleteButton: false,
            extraData: Object.assign({}, defaultExtraData)
        });
    }

    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to delete?"
        });
    }

    clearData = () => {
        let obj = Object.assign({}, defaultLicense);
        this.setState({license: obj, renderExtraDataDeleteButton: false});
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let license = this.state.license;
        license[e.target.name] = value;
        if (e.target.name == "serviceName" && value != "ARTPOS" && value != "PRINTSEL" || value != "ARTOFFICE") {
            license['extraData'] = {};
        }
        this.setState({license: license});
    }

    __handleChangeExtraData = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let extraData = this.state.extraData;
        extraData[e.target.name] = value;
        this.setState({extraData: extraData});
    }

    __handleChangeStatus = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let license = this.state.license;
        if (value == 'DEMO') {
            license['validDays'] = '30';
        } else {
            license['validDays'] = '0';
        }
        license[e.target.name] = value;
        this.setState({license: license});
    }
}

AppLicenseSave.propTypes =
    {
        license: PropTypes.object
    }
;
